export default function ActivityConfRouter(Layout, device) {
  console.log('ActivityConfRouter---', device);
  return [
    {
      path: '/activityConf', // 活动配置相关
      name: 'actConf',
      redirect: '/activityConf/list',
      component: Layout,
      meta: {
        title: '活动配置',
        icon: 'icon-act',
        activePath: 'activityConf',
      },
      children: [
        {
          path: 'article/:id',
          name: 'actArticleConf',
          meta: {
            title: '文章配置',
            activePath: 'article',
          },
          prop: true,
          hidden: true,
          component: () =>
            import(`../views/activityConf/${device}/article.vue`),
        },
        {
          path: 'trend/:id',
          name: 'actTrendConf',
          meta: {
            title: '动态关联配置',
            activePath: 'trend',
          },
          prop: true,
          hidden: true,
          component: () => import(`../views/activityConf/${device}/trend.vue`),
        },
        {
          path: 'list',
          name: 'actArticleConfList',
          meta: {
            title: '文章列表',
            activePath: 'list',
            showSideBar: true,
          },
          component: () => import(`../views/activityConf/${device}/list.vue`),
        },
        {
          path: 'trendList',
          name: 'actTrendConfList',
          meta: {
            title: '动态列表',
            activePath: 'trendList',
            showSideBar: true,
          },
          component: () =>
            import(`../views/activityConf/${device}/trendList.vue`),
        },
        // {
        //   path: "actList",
        //   name: "actConfList",
        //   meta: {
        //     title: "活动列表",
        //     activePath: "actList",
        //     showSideBar: true,
        //   },
        //   component: () => import(`../views/activityConf/${device}/actList.vue`),
        // },
        // {
        //   path: "lottery",
        //   name: "actLotteryConf",
        //   meta: {
        //     title: "抽奖配置",
        //     activePath: "lottery",
        //     showSideBar: true,
        //   },
        //   component: () =>
        //     import(`../views/activityConf/${device}/lottery.vue`),
        // },
      ],
    },
  ];
}
